import { render } from "./InputEmotion.vue?vue&type=template&id=3578cb56"
import script from "./InputEmotion.vue?vue&type=script&lang=js"
export * from "./InputEmotion.vue?vue&type=script&lang=js"
script.render = render

export default script